import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import AddPaymentType from './AddPaymentType';
import PaymentTypes from './PaymentTypes';
import ViewPaymentType from './ViewPaymentType';
import EditPaymentType from './EditPaymentType';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/payment-type' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainPaymentType = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.master || {}; // Only using 'master' permissions

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<PaymentTypes />} />

        <Route
          path='/add-payment-type'
          element={<ProtectedRoute element={<AddPaymentType />} permission={Permission.create} />}
        />

        <Route
          path='/view-payment-type'
          element={<ProtectedRoute element={<ViewPaymentType />} permission={Permission.read} />}
        />

        <Route
          path='/edit-payment-type'
          element={<ProtectedRoute element={<EditPaymentType />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainPaymentType;
